export default __webpack_public_path__ + "static/media/caller.b43493a3.svg";